import { render } from "./ConversationSharedFileRow.vue?vue&type=template&id=befb5136&ts=true"
import script from "./ConversationSharedFileRow.ts?vue&type=script&lang=ts&external"
export * from "./ConversationSharedFileRow.ts?vue&type=script&lang=ts&external"

import "./ConversationSharedFileRow.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__